import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./partial/Header";
import Sidebar from "./partial/Sidebar";
import JoditEditor from "jodit-react";
import toast, { Toaster } from "react-hot-toast";
import ChangePassword from "./partial/ChangePassword";
import { themeImgUrl, ImgUrl } from "../Constant";
import {
  useGetThemeByIdQuery,
  useUpdateThemeMutation,
} from "../../redux/API/ThemeApi";

const UpdateTheme = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const { slug } = useParams();
  const { data, refetch } = useGetThemeByIdQuery(slug);
  console.log(data, "themeData");

  const overviewEditor = useRef(null);
  const otherInfoEditor = useRef(null);
  const itineraryEditor = useRef(null);
  const fileInputRef = useRef(null); 
  const { name, overview, otherInfo, itinerary, image } = data?.data || {
    name: "",
    overview: "",
    otherInfo: "",
    itinerary: "",
    image: null,
  };

  const [updateImage, setUpdateImage] = useState(null);
  const [themeData, setThemeData] = useState({ name: name });
  const [content, setContent] = useState({
    overview: overview,
    otherInfo: otherInfo,
    itinerary: itinerary,
  });

  const [showError, setShowError] = useState({
    name: false,
    overview: false,
    otherInfo: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setThemeData({ name: data?.theme?.name });
      setContent({
        overview: data?.theme?.overview,
        otherInfo: data?.theme?.otherInfo,
        itinerary: data?.theme?.itinerary,
      });
      setUpdateImage(data?.data?.image);
    }
    refetch();
  }, [data, refetch]);

  const [postData] = useUpdateThemeMutation();

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
  
    const sizeLimit = 2 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
  
    const ext = file.name.split('.').pop().toLowerCase();
    const isValidType = allowedTypes.includes(file.type);
    const isValidExtension = allowedExtensions.includes(ext);
  
    const resetInput = () => {
      setUpdateImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        // Handle re-selection of the same file
        e.target.type = '';
        e.target.type = 'file';
      }
    };
  
    if (!isValidType || !isValidExtension) {
      toast.error("Invalid file format. Only JPG, JPEG, PNG, WEBP are allowed.");
      resetInput();
      return;
    }
  
    if (file.size > sizeLimit) {
      toast.error("File size should be less than 2MB");
      resetInput();
      return;
    }
  
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.src = objectUrl;
  
    img.onload = () => {
      if (img.width === 1500 && img.height === 400) {
        setUpdateImage({
          file,
          preview: objectUrl,
        });
      } else {
        toast.error("Image dimensions must be 1500x400 pixels");
        resetInput();
        URL.revokeObjectURL(objectUrl);
      }
    };
  
    img.onerror = () => {
      toast.error("Invalid image file.");
      resetInput();
      URL.revokeObjectURL(objectUrl);
    };
  };
  

  const handleUpdateTheme = (e) => {
    e.preventDefault();

    const checkField = {
      name: themeData.name === "",
      overview: content.overview === "",
      otherInfo: content.otherInfo === "",
    };

    setShowError(checkField);
    const hasError = Object.values(checkField).some((error) => error);
    if (hasError) return;

    const formData = new FormData();

    if (updateImage?.file) {
      formData.append("image", updateImage.file);
    }

    formData.append("name", themeData.name);
    formData.append("overview", content.overview);
    formData.append("otherInfo", content.otherInfo);
    formData.append("itinerary", content.itinerary);
    formData.append("slug", slug);
    console.log("Printing the form data here ",formData)

    console.log(" Printing the form data : ");
    for (let pair of formData.entries()) {
      console.log(pair[0] + " : ", pair[1]);
    }

    postData({slug:slug,data:formData})
      .then((res) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message || "Theme updated successfully!");
          navigate("/admin/themes");
        } else {
          toast.error(res?.error?.data?.message || "Something went wrong, Please try later.");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };

  const handleToggle = () => {
    setNewClass((prev) => (prev === "" ? "main-active" : ""));
    setNewSidebarClass((prev) => (prev === "" ? "closed" : ""));
  };

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} setShowPass={setShowPass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Update Theme
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/themes" className="btn btn-primary rounded-2">
              Back <FaArrowLeft />
            </Link>
          </div>
          <div className="container card p-4">
            <form className="row gy-3" onSubmit={handleUpdateTheme}>
              <div className="col-lg-6">
                <label htmlFor="name">
                  Theme Name <sup className="text-danger fs-6">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter Theme Name"
                  value={themeData.name}
                  onChange={(e) =>
                    setThemeData({ ...themeData, name: e.target.value })
                  }
                />
                {showError.name && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Theme Name
                  </p>
                )}
              </div>

              <div className="col-lg-6">
                <label htmlFor="image">Image</label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  name="image"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                />
                <div className="row mt-2">
                  {updateImage && (
                    <div className="col-lg-3 border border-2 mt-2">
                      <img
                        src={
                          updateImage.preview ||
                          `${ImgUrl}${themeImgUrl}${updateImage}`
                        }
                        alt="Preview"
                        width={80}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="col-lg-12">
                <label htmlFor="overview">
                  Overview <sup className="text-danger fs-6">*</sup>
                </label>
                <JoditEditor
                  ref={overviewEditor}
                  value={content.overview}
                  onChange={(newContent) =>
                    setContent({ ...content, overview: newContent })
                  }
                />
                {showError.overview && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Overview
                  </p>
                )}
              </div>

              <div className="col-lg-12">
                <label htmlFor="otherInfo">
                  Other Information <sup className="text-danger fs-6">*</sup>
                </label>
                <JoditEditor
                  ref={otherInfoEditor}
                  value={content.otherInfo}
                  onChange={(newContent) =>
                    setContent({ ...content, otherInfo: newContent })
                  }
                />
                {showError.otherInfo && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Other Information
                  </p>
                )}
              </div>
              <div className="col-lg-12">
                <label htmlFor="otherInfo">
                  itinerary <sup className="text-danger fs-6">*</sup>
                </label>
                <JoditEditor
                  ref={itineraryEditor}
                  value={content.itinerary}
                  onChange={(newContent) =>
                    setContent({ ...content, itinerary: newContent })
                  }
                />
                {showError.otherInfo && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Other Information
                  </p>
                )}
              </div>

              {/* <div className="col-lg-12">
                <label htmlFor="itinerary">Itinerary</label>
                <textarea
                  className="form-control"
                  id="itinerary"
                  rows="4"
                  placeholder="Enter Itinerary"
                  value={content.itinerary}
                  onChange={(e) => setContent({ ...content, itinerary: e.target.value })}
                />
              </div> */}

              <div className="col-lg-12 pt-4">
                <button
                  className="btn btn-primary px-4 rounded-2"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default UpdateTheme;
